import React from 'react';

const FilterSidebar = () => {
  return (
    <aside className="w-1/4 p-4 border-r border-gray-200">
      <h3 className="text-lg font-bold mb-4">Filter By</h3>
      <div className="mb-4">
        <h4 className="text-md font-semibold">Department</h4>
        <ul>
          <li><input type="checkbox" id="engineering" /> <label htmlFor="engineering">Engineering</label></li>
          <li><input type="checkbox" id="product" /> <label htmlFor="product">Product</label></li>
          <li><input type="checkbox" id="marketing" /> <label htmlFor="marketing">Marketing</label></li>
        </ul>
      </div>
      <div>
        <h4 className="text-md font-semibold">Type</h4>
        <ul>
          <li><input type="checkbox" id="full-time" /> <label htmlFor="full-time">Full-time</label></li>
          <li><input type="checkbox" id="internship" /> <label htmlFor="internship">Internship</label></li>
          <li><input type="checkbox" id="contract" /> <label htmlFor="contract">Contract</label></li>
        </ul>
      </div>
    </aside>
  );
};

export default FilterSidebar;
